import { Actions } from '../enums/ActionEnums';
import { ActionType } from '../models/appContext';
import { ContactType } from '../models/contact';

export const contactReducer = (state: ContactType, action: ActionType): ContactType => {
  switch (action.type) {
    case Actions.SetSelectedContact:
      return {
        name: action.payload.name,
        company_name: action.payload.company_name
      };
    case Actions.ResetSelectedContact:
      return {
        name: null,
        company_name: null
      };
    default:
      return state;
  }
};
